import { safeJsonParse } from '@/modules/shared/utils/safeJsonParse'

export const dataPersistenceMapper = (data: string, typeNames?: string[]) => {
  const filteredData: Record<string, unknown> = {}
  const parsedData = safeJsonParse(data)

  if (!typeNames) return data

  Object.keys(parsedData).forEach((key) => {
    const typeName = key.split(':')[0]

    if (typeNames.includes(typeName)) {
      filteredData[key] = parsedData[key]
    }
  })

  return JSON.stringify(filteredData)
}
